var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workspace-selector" },
    _vm._l(_vm.clientList, function(client) {
      return _c(
        "button",
        {
          key: client.clientId,
          staticClass: "workspace-option",
          class: { "is-current": _vm.isCurrent(client) },
          attrs: {
            type: "button",
            "aria-current": _vm.isCurrent(client) ? "true" : null
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.handleClientSelection(client)
            }
          }
        },
        [
          _c("span", { staticClass: "workspace-avatar" }, [
            _vm._v(_vm._s(_vm.getClientInitials(client.clientName)))
          ]),
          _c("span", { staticClass: "workspace-name" }, [
            _vm._v(_vm._s(client.clientName))
          ]),
          _vm.isCurrent(client)
            ? _c("portal-icon", {
                staticClass: "workspace-check",
                attrs: { name: "check", size: 17 }
              })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }